import { HeadData } from '@/components/HeadData';
import { graphql } from '@/gql/codegen/gql';
import { useSuspenseQuery } from '@apollo/client';
import { createFileRoute } from '@tanstack/react-router';
import { UserEnrollmentContainer } from '../-container';
export const Route = createFileRoute('/_embaUserLayout/_learnerLayout/')({
  component: component,
});

export const GET_CURRENT_USER_ENROLLMENT = graphql(/* GraphQL */ `
  query UserEnrollmentPage {
    currentEmbaUserEnrollment {
      ...UserEnrollmentForContainer
    }
    embaImportantNotification {
      ...EmbaImportantNotification
    }
  }
`);

function component() {
  const { error, data } = useSuspenseQuery(GET_CURRENT_USER_ENROLLMENT);

  if (error) {
    throw error;
  }

  return (
    <>
      <HeadData title="科目一覧" />
      <UserEnrollmentContainer
        currentEmbaUserEnrollment={data.currentEmbaUserEnrollment}
        importantNotification={data.embaImportantNotification || null}
      />
    </>
  );
}
